// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"inbox_wrapper__rPd1u","chatWidth":"inbox_chatWidth__17RiX","messageWrapper":"inbox_messageWrapper__3NQB8"};